/**
 * What gets stored in the applications table is the name from leadSourceMap (libs/data/leadSourcesMap.ts), NOT THIS UPPERCASE ENUM
 */
export enum LeadSourceType {
  Alfalfa = 'ALFALFA',
  Agc = 'AGC',
  AgcIncentive = 'AGCINCENTIVE',
  Amazon = 'AMAZON',
  AmazonBenefitsDemo = 'AMAZONBENEFITSDEMO',
  Backfill = 'BACKFILL',
  BuilderReferral = 'BUILDERREFERRAL',
  Bankrate = 'BANKRATE',
  BankrateAlfie = 'BANKRATEALFIE',
  BankrateCall = 'BANKRATECALL',
  BankrateCashOutEmail = 'BANKRATECASHOUTEMAIL',
  BankrateCPC = 'BANKRATECPC',
  BankrateDigiFlex = 'BANKRATEDIGIFLEX',
  BankrateEmail = 'BANKRATEEMAIL',
  BankrateFedEmail = 'BANKRATEFEDEMAIL',
  BankratePrimary = 'BANKRATEPRIMARY',
  BankrateSecondary = 'BANKRATESECONDARY',
  BestMoneyCashoutClick = 'BESTMONEYCASHOUTCLICK',
  Barcelona = 'BARCELONA',
  BarcelonaIncentive = 'BARCELONAINCENTIVE',
  Bing = 'BING',
  CalendlyAppointment = 'CALENDLYAPPOINTMENT',
  Confia = 'CONFIA',
  ConfiaIncentive = 'CONFIAINCENTIVE',
  ConsumerAffairs = 'CONSUMERAFFAIRS',
  CPC = 'CPC',
  CustomerReferral = 'CUSTOMERREFERRAL',
  DirectResidential = 'DIRECTRESIDENTIAL',
  DirectResidentialIncentive = 'DIRECTRESIDENTIALINCENTIVE',
  ElijahAnthony = 'ELIJAHANTHONY',
  ElijahAnthonyIncentive = 'ELIJAHANTHONYINCENTIVE',
  Encore = 'ENCORE',
  EncoreIncentive = 'ENCOREINCENTIVE',
  EmployeeLoans = 'EMPLOYEELOANS',
  ExistingCustomerReferral = 'EXISTINGCUSTOMERREFERRAL',
  Facebook = 'FACEBOOK',
  Facet = 'FACET',
  Fed = 'FED',
  FiSpoke = 'FISPOKE',
  FreeRateUpdate = 'FREERATEUPDATE',
  HarrisTeeter = 'HARRISTEETER',
  HomeEquityCPC = 'HOMEEQUITYCPC',
  HomeEquityPrimary = 'HOMEEQUITYPRIMARY',
  HomeEquitySecondary = 'HOMEEQUITYSECONDARY',
  HomeLight = 'HOMELIGHT',
  Hrm = 'HRM',
  HrmIncentive = 'HRMINCENTIVE',
  HSH = 'HSH',
  InboundCall = 'INBOUNDCALL',
  LeadPointPosted = 'LEADPOINTPOSTED',
  LendingTree = 'LENDINGTREE',
  LoanEstimateComparison = 'LOANESTIMATECOMPARISON',
  LowerMyBills = 'LOWERMYBILLS',
  LowerMyBillsShortForm = 'LOWERMYBILLSSHORTFORM',
  MilitaryVALoan = 'MILITARYVALOAN',
  MortgageLenderComparisonCashOutRefiClick = 'MORTGAGELENDERCOMPARISONCASHOUTREFICLICK',
  MrcPurchaseCpc = 'MRCPURCHASECPC',
  MrcPremiumPurchaseCpc = 'MRCPREMIUMPURCHASECPC',
  MrcRefinanceCpc = 'MRCREFINANCECPC',
  MrcPremiumRefinanceCpc = 'MRCPREMIUMREFINANCECPC',
  MyAgentFinder = 'MYAGENTFINDER',
  NerdWallet = 'NERDWALLET',
  PersonalReferral = 'PERSONALREFERRAL',
  PropertyMate = 'PROPERTYMATE',
  Puma = 'PUMA:UI',
  PurchaseReferrals = 'PURCHASEREFERRALS',
  RateZip = 'RATEZIP',
  RealtorReferral = 'REALTORREFERRAL',
  Refily = 'REFILY',
  RetClientForLifeOB = 'RETCLIENTFORLIFEOB',
  Reporting = 'REPORTING',
  Robinhood = 'ROBINHOOD',
  RVMN = 'RVMN',
  SageMortgageEmail = 'SAGEMORTGAGEEMAIL',
  SageRadio = 'SAGERADIO',
  SageWebsite = 'SAGEWEBSITE',
  SEM = 'SEM',
  Sims = 'SIMS',
  SMARTASSET = 'SMARTASSET',
  SupportPhoneNumber = 'SUPPORTPHONENUMBER',
  TheMortgageReport = 'THEMORTGAGEREPORT',
  Top10 = 'TOP10',
  Transunion = 'TRANSUNION',
  Unmapped = 'UNMAPPED',
  WhiteTree = 'WHITETREE',
  WhiteTreeIncentive = 'WHITETREEINCENTIVE',
  YearyHauco = 'YEARYHAUCO',
  YearyHaucoIncentive = 'YEARYHAUCOINCENTIVE',
  Zillow = 'ZILLOW',
}
